import angular from 'angular';
import asDate from './as-date.directive';

export default angular
  .module('verifyApp.as-date', [])
  .directive('asDate', asDate)
  .name;



// WEBPACK FOOTER //
// ./client/components/as-date/index.js